import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneFieldFilled(field1: string, field2: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const control1 = group.get(field1);
    const control2 = group.get(field2);

    if (!control1 || !control2) return null;

    const value1 = control1.value;
    const value2 = control2.value;

    // Si au moins un champ a une valeur, tout est OK
    if (value1?.length || value2?.length) return null;

    // Sinon on met une erreur sur le groupe
    return { atLeastOneRequired: true };
  };
}
